module.exports = __webpack_public_path__ + "static/assets/a42f3e375714dfc9e240ad5d695ea4f5.png";